





































































































/* General */
import Vue from 'vue'
import { debounce } from 'lodash'

/* Mixins */

/* Components */
import DdGlobalSearchEmpty from './components/app-header-global-search-empty.vue'
import DdGlobalSearchAvatarRow from './components/app-header-global-search-avatar-row.vue'
import DdGlobalSearchLoading from './components/app-header-global-search-loading.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { EEntities } from '@/types'
import {
  ISearchItemResult,
  ISearchOutputIndex,
  IItemForSelection,
} from '@/api/types/response.types'

/* API */
import SearchAPI from '@/api/modules/search.api'

export default Vue.extend({
  name: 'AppHeaderGlobalSearch',

  components: {
    DdGlobalSearchEmpty,
    DdGlobalSearchAvatarRow,
    DdGlobalSearchLoading,
  },

  props: {
    searchActive: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      EEntities,
      searchQuery: '',
      debounceGetResults: null,
      errorText: '',

      globalSearchIsLoading: false,
      globalSearchResults: {} as ISearchOutputIndex,
    }
  },

  computed: {
    globalSearchMailboxes(): IItemForSelection[] {
      return this.globalSearchResults.mailboxes
    },

    globalSearchProjects(): IItemForSelection[] {
      return this.globalSearchResults.projects
    },

    globalSearchMatches(): ISearchItemResult[] {
      return this.globalSearchResults.matches
    },

    setStyleDropdown(): boolean {
      return (
        (this.getGlobalSearchLength === 0 &&
          !this.globalSearchIsLoading &&
          !this.showNoResults) ||
        this.searchQuery.length < 2
      )
    },

    hasMailboxOrProject(): boolean {
      let length = 0
      if (this.globalSearchMailboxes) {
        length += this.globalSearchMailboxes.length
      }
      if (this.globalSearchProjects) {
        length += this.globalSearchProjects.length
      }
      return length > 0
    },

    hasSearchMatches(): boolean {
      return this.globalSearchMatches && this.globalSearchMatches.length > 0
    },

    getGlobalSearchLength(): number {
      let length = 0
      if (this.globalSearchResults !== null) {
        if (this.globalSearchResults.mailboxes) {
          length += this.globalSearchResults.mailboxes.length
        }
        if (this.globalSearchResults.projects) {
          length += this.globalSearchResults.projects.length
        }
        if (this.globalSearchResults.matches) {
          length += this.globalSearchResults.matches.length
        }
      }
      return length
    },

    showNoResults(): boolean {
      return (
        this.searchActive &&
        this.getGlobalSearchLength === 0 &&
        this.searchQuery.length > 2 &&
        !this.globalSearchIsLoading
      )
    },

    emptySearchText(): string {
      if (this.errorText !== '') {
        return this.errorText
      }
      if (this.showNoResults) {
        return 'No results found'
      }
      return null
    },
  },

  watch: {
    async searchQuery() {
      if (this.searchQuery.length >= 2) {
        await this.debounceGetResults()
        // @ts-ignore
        if (this.$refs.dropdownRef) {
          // @ts-ignore
          this.$refs.dropdownRef.$emit('visible', true)
        }
      }
    },
    searchActive(val: boolean) {
      if (val === true) {
        this.$nextTick(() => {
          // @ts-ignore
          this.$refs.globalInput.focus()
          if (this.searchQuery.length >= 2 && this.$refs.dropdownRef) {
            // @ts-ignore
            this.$refs.dropdownRef.$emit('visible', true)
          }
        })
      }
    },
  },

  mounted() {
    this.getSearchItemResults()
  },

  created() {
    this.debounceGetResults = debounce(this.getSearchItemResults, 500)
  },

  methods: {
    closeSearch() {
      this.searchQuery = ''
      this.$emit('toggle-search', false)
    },

    async getSearchItemResults() {
      this.errorText = ''
      if (this.searchQuery === '') {
        return
      }

      this.globalSearchResults = {} as ISearchOutputIndex
      this.globalSearchIsLoading = true

      try {
        this.globalSearchResults = await SearchAPI.post_Index(this.searchQuery)
      } catch (err) {
        // @ts-ignore
        this.errorText = err.data.message
      } finally {
        this.globalSearchIsLoading = false
      }
    },

    sendToHome(type: string, entityID: any, title: string) {
      if (type === EEntities.MAILBOXES) {
        RouteAssistant.goToMailbox(
          this.$router,
          this.$route.params.accountId,
          entityID,
          title,
        )
      } else {
        RouteAssistant.goToProjectLanding(
          this.$router,
          this.$route.params.accountId,
          entityID,
          this.$permissions,
          title,
        )
      }
    },
    /**
     * Send to comment/reply URL
     */
    sendToComment(url: string) {
      window.location.href = url
    },

    /**
     * Update v-model as @input is triggered.
     */
    change(val: any) {
      this.searchQuery = val
    },
  },
})
